// extracted by mini-css-extract-plugin
export default {"arrowsContainer":"d6Fb1dyBIHOEBPxcRXM9jA==","tabsContainer":"whxdWZfRPMH7gDRJuCQO5w==","tab":"_9vHdCwyIauiuyZix6x2CnA=="};